import { render, staticRenderFns } from "./buy-unit-price.vue?vue&type=template&id=73c2f896&scoped=true"
import script from "./buy-unit-price.vue?vue&type=script&lang=js"
export * from "./buy-unit-price.vue?vue&type=script&lang=js"
import style0 from "./buy-unit-price.vue?vue&type=style&index=0&id=73c2f896&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c2f896",
  null
  
)

export default component.exports